import { render, staticRenderFns } from "./RecentOnboardings.vue?vue&type=template&id=0fc1ba9e&scoped=true&"
import script from "./RecentOnboardings.vue?vue&type=script&lang=js&"
export * from "./RecentOnboardings.vue?vue&type=script&lang=js&"
import style0 from "./RecentOnboardings.vue?vue&type=style&index=0&id=0fc1ba9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc1ba9e",
  null
  
)

export default component.exports